<template>
  <div class="my_shop_record">
    <div class="columtitle">购买记录</div>
    <div class="sccont">
      <div class="listhea flex_end">
        <el-select
          v-model="typevalue"
          placeholder="分类"
          @change="selechange"
          class="selec"
        >
          <el-option
            v-for="item in typelist"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select v-model="sortvalue" placeholder="全部时间" class="selec">
          <el-option
            v-for="item in sortlist"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="sprdlist">
        <div class="sprditem flex_start mt20" v-for="item in 5" :key="item">
          <div class="sprdcove">
            <img src="~assets/zx_consult/consult_cover_sample.png" alt="" />
          </div>
          <div class="sprdtxt">
            <div class="buytitle ellipsis">
              新建设工程施工合同（示范文本）
              </div>
            <div class="fs1499 mt20">2021-04-21 17:52:00</div>
            <div class="fs1499 mt20">￥9.9</div>
            <div class="buystatus center">已购买</div>
          </div>
        </div>
      </div>

      <div class="pagination mt50">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="pageCount"
          :current-page="currentPage"
          :pager-count="5"
          @current-change="turnpage"
          @prev-click="turnpage(--currentPage)"
          @next-click="turnpage(++currentPage)"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1, //当前
      pageCount: 17, //总页数
      total: 17, //总条目
      typelist: [
        {
          value: "音频",
          label: "音频",
        },
        {
          value: "视频",
          label: "视频",
        },
        {
          value: "文章",
          label: "文章",
        },
      ],
      typevalue: "",

      sortlist: [
        {
          value: "最新value",
          label: "最新label",
        },
        {
          value: "一月内value",
          label: "一月内label",
        },
      ],
      sortvalue: "",
    };
  },
  methods: {
    selechange(e) {
      console.log(e);
    },
    turnpage(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.my_shop_record {
  box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.11);
  .columtitle {
    width: 100%;
    height: 90px;
    line-height: 90px;
    padding-left: 30px;
    background: #f4f4f4;
    font-size: 20px;
    color: #333333;
  }
  .sccont {
    padding: 30px;
    .listhea {
      .selec {
        width: 120px;
        margin-left: 30px;
      }
      ::v-deep .el-input--suffix .el-input__inner {
        border-radius: 30px;
      }
    }
    .sprdlist {
      .sprditem {
        border: 1px solid #dddddd;
        position: relative;
        padding: 15px;
        cursor: pointer;
        .sprdcove {
          margin-right: 24px;
          img {
            width: 174px;
            height: 114px;
          }
        }
        .sprdtxt {
          width:650px;
          .buytitle {
            font-size: 18px;
            color: #333333;
          }
          .fs1499 {
            font-size: 14px;
            color: #999999;
          }
        }
        .buystatus {
          position: absolute;
          right: 22px;
          top: 0;
          height: 100%;
          font-size: 18px;
          color: #444444;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    ::v-deep .el-pagination.is-background .btn-next,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination button,
    ::v-deep .el-pagination span:not([class*="suffix"]),
    ::v-deep .el-pagination.is-background .el-pager li {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ffffff !important;
      background: #0057ff !important;
    }
  }
}
</style>